enum DriverEditViewMode {
  TAXI = "TAXI",
  RAILY = "RAILY",
}

export default DriverEditViewMode;
